import { createApiRequest } from "@/lib/api/createApiService";
import { CUSTOM_FRAMEWORK_ENDPOINTS as EP } from "./customFramework.endpoints";

export const customFrameworkService = {
  // Frameworks
  list: () => createApiRequest({ url: EP.LIST, method: "GET" }),

  get: (id) => createApiRequest({ url: EP.DETAIL(id), method: "GET" }),

  create: (data) =>
    createApiRequest({ url: EP.CREATE, method: "POST", body: data }),

  update: (id, data) =>
    createApiRequest({ url: EP.UPDATE(id), method: "PATCH", body: data }),

  remove: (id) => createApiRequest({ url: EP.DELETE(id), method: "DELETE" }),

  uploadLogo: (id, file) => {
    const formData = new FormData();
    formData.append("logo", file);
    return createApiRequest({
      url: EP.LOGO(id),
      method: "PATCH",
      body: formData,
      isFormData: true,
    });
  },

  // Disclosures
  listDisclosures: (frameworkId) =>
    createApiRequest({ url: EP.DISCLOSURES(frameworkId), method: "GET" }),

  addDisclosure: (frameworkId, data) =>
    createApiRequest({
      url: EP.DISCLOSURES(frameworkId),
      method: "POST",
      body: data,
    }),

  updateDisclosure: (frameworkId, discId, data) =>
    createApiRequest({
      url: EP.DISCLOSURE(frameworkId, discId),
      method: "PATCH",
      body: data,
    }),

  removeDisclosure: (frameworkId, discId) =>
    createApiRequest({
      url: EP.DISCLOSURE(frameworkId, discId),
      method: "DELETE",
    }),

  bulkUpsertDisclosures: (frameworkId, disclosures) =>
    createApiRequest({
      url: EP.DISCLOSURES_BULK(frameworkId),
      method: "POST",
      body: { disclosures },
    }),
};
